module.exports = __webpack_public_path__ + "img/6b023dd73a5b57a55116677b530a78a.7c89183c.jpg";